const awsConfig = {
    aws_app_analytics: 'enable',

    aws_user_pools: 'enable',
    aws_user_pools_id: 'us-east-1_iRdoeoPrI',
    aws_user_pools_mfa_type: 'OFF',
    aws_user_pools_web_client_id: '5havsel3v07o8lmlt9fm5b506t',
    aws_user_settings: 'enable',
};

export default awsConfig
